import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import pfp from 'assets/pfp.png';

// Screensaver — after IDLE_MS with no input, a bouncing (DVD-style) INTERNET/MSFT mark on black.
// Desktop only (≥768px), any input dismisses, the animation stops when hidden or dismissed so it
// never heats a phone. (A My Pictures slideshow lived here for one evening on 2026-09-12; Kris
// wanted the original back — the slide show is still in My Pictures → "View as a slide show".)

const IDLE_MS = 60000;

export default function Screensaver() {
  const [on, setOn] = useState(false);
  const timer = useRef(null);
  const raf = useRef(null);
  const el = useRef(null);

  useEffect(() => {
    if (window.innerWidth < 768) return undefined;
    // Playing a game, watching a film or browsing the old web happens inside an iframe (or the
    // in-page DOS emulator) — our document sees no input then, so idle must not mean idle.
    const busy = () =>
      !!document.querySelector('.ar__frame, .ar__dos, .wmp__frame, .pb__frame, .ie__frame, .pic__preview') ||
      (document.activeElement && document.activeElement.tagName === 'IFRAME');
    const arm = () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        if (busy()) arm();
        else setOn(true);
      }, IDLE_MS);
    };
    const wake = () => {
      setOn(false);
      arm();
    };
    const evts = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'scroll', 'blur', 'focus'];
    evts.forEach(e => window.addEventListener(e, wake, { passive: true }));
    arm();
    return () => {
      clearTimeout(timer.current);
      evts.forEach(e => window.removeEventListener(e, wake));
    };
  }, []);

  useEffect(() => {
    if (!on) return undefined;
    const node = el.current;
    if (!node) return undefined;
    let x = 80;
    let y = 80;
    let vx = 2.2;
    let vy = 1.7;
    const w = 260;
    const h = 120;
    const step = () => {
      if (document.hidden) {
        raf.current = requestAnimationFrame(step);
        return;
      }
      const W = window.innerWidth;
      const H = window.innerHeight;
      x += vx;
      y += vy;
      if (x <= 0 || x + w >= W) vx = -vx;
      if (y <= 0 || y + h >= H) vy = -vy;
      x = Math.max(0, Math.min(W - w, x));
      y = Math.max(0, Math.min(H - h, y));
      node.style.transform = `translate(${x}px, ${y}px)`;
      raf.current = requestAnimationFrame(step);
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [on]);

  if (!on) return null;
  return (
    <Screen>
      <div className="ss__mark" ref={el}>
        <img src={pfp} alt="" />
        <div>
          <div className="ss__t">INTERNET / MSFT</div>
          <div className="ss__s">the pot grows while you're away.</div>
          <div className="ss__s">the next epoch is coming. (real)</div>
        </div>
      </div>
      <div className="ss__hint">move the mouse to log back on</div>
    </Screen>
  );
}

const Screen = styled.div`
  position: absolute; /* the CRT screen, not the browser viewport — the monitor stays visible */
  inset: 0;
  z-index: 99998;
  background: #000;
  color: #ccff00;
  font-family: Tahoma, sans-serif;
  overflow: hidden;
  .ss__mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 260px;
    height: 120px;
    display: flex;
    align-items: center;
    gap: 14px;
    will-change: transform;
    img {
      width: 84px;
      height: 84px;
      filter: drop-shadow(0 0 18px rgba(204, 255, 0, 0.7));
    }
  }
  .ss__t {
    font-size: 18px;
    letter-spacing: 3px;
    color: #fff;
    margin-bottom: 4px;
  }
  .ss__s {
    font-size: 11px;
    color: #8fb800;
  }
  .ss__hint {
    position: absolute;
    bottom: 24px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 11px;
    letter-spacing: 2px;
    color: #3a5000;
  }
`;
